import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IFermenterVM } from 'app/models/fermenter';
import { FermenterGrainfatherSvgComponent } from '../fermenter-grainfather-svg/fermenter-grainfather-svg.component';
import { FermenterConicalSvgComponent } from '../fermenter-conical-svg/fermenter-conical-svg.component';
import { FermenterBucketSvgComponent } from '../fermenter-bucket-svg/fermenter-bucket-svg.component';
import { FermenterCarboySvgComponent } from '../fermenter-carboy-svg/fermenter-carboy-svg.component';
import { FermenterPressureSvgComponent } from '../fermenter-pressure-svg/fermenter-pressure-svg.component';
import { FermenterKegmenterSvgComponent } from '../fermenter-kegmenter-svg/fermenter-kegmenter-svg.component';

/**
 * Picks the fermenter vessel graphic by `item.type`. Consumers use a single
 * <app-fermenter-svg [item]="fermenter"/> (mirrors how the keg SVGs are chosen
 * by container). Falls back to the generic stainless conical.
 */
@Component({
  selector: 'app-fermenter-svg',
  templateUrl: './fermenter-svg.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FermenterGrainfatherSvgComponent,
    FermenterConicalSvgComponent,
    FermenterBucketSvgComponent,
    FermenterCarboySvgComponent,
    FermenterPressureSvgComponent,
    FermenterKegmenterSvgComponent,
  ],
  styles: [':host{display:block;width:100%;height:100%}'],
})
export class FermenterSvgComponent {
  @Input() item!: IFermenterVM;
}
